import { AiEngineEnum, UniversalChatEngineEnum } from 'gql/graphql';
import { useTranslations } from 'next-intl';
import { useFeatureFlags } from 'providers/ClientProviders/useFeatureFlags';
import { Option } from 'types/Option';

export const AllEnginesEnum = {
  ...UniversalChatEngineEnum,
  ...AiEngineEnum
} as const;

export type AllEnginesType = UniversalChatEngineEnum | AiEngineEnum;

interface IUseOptionsModelsIn {
  blackList?: AllEnginesType[];
}

interface IUseOptionsModelsOut {
  optionsModels: Option[];
}

export default function useOptionsModels({
  blackList
}: IUseOptionsModelsIn = {}): IUseOptionsModelsOut {
  const { data: featureFlags } = useFeatureFlags();
  const t = useTranslations();

  const optionsModels = [
    {
      label: t(`engines.${AllEnginesEnum.Opus}`),
      value: AllEnginesEnum.Opus
    },
    {
      label: t(`engines.${AllEnginesEnum.Opus_46}`),
      value: AllEnginesEnum.Opus_46
    },
    {
      label: t(`engines.${AllEnginesEnum.Anthropic}`),
      value: AllEnginesEnum.Anthropic
    },
    {
      label: t(`engines.${AllEnginesEnum.ChatGpt5}`),
      value: AllEnginesEnum.ChatGpt5
    },
    {
      label: t(`engines.${AllEnginesEnum.ChatGpt4o}`),
      value: AllEnginesEnum.ChatGpt4o
    },
    {
      label: t(`engines.${AllEnginesEnum.ChatGpt4}`),
      value: AllEnginesEnum.ChatGpt4
    },
    ...(featureFlags?.aiLlamaEnabled
      ? [
          {
            label: t(`engines.${AllEnginesEnum.Tolq_3b}`),
            value: AllEnginesEnum.Tolq_3b
          }
        ]
      : []),
    {
      label: t(`engines.${AllEnginesEnum.ChatGpto1Preview}`),
      value: AllEnginesEnum.ChatGpto1Preview
    },
    {
      label: t(`engines.${AllEnginesEnum.ChatGpto1Mini}`),
      value: AllEnginesEnum.ChatGpto1Mini
    },
    ...(featureFlags?.haikuEnabled
      ? [
          {
            label: t(`engines.${AllEnginesEnum.Haiku}`),
            value: AllEnginesEnum.Haiku
          }
        ]
      : [])
  ].filter(({ value }) => !blackList?.includes(value));

  return { optionsModels };
}
